import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

const RedoFulfillmentToteGroupSchema_ = z
  .object({
    _id: zExt.objectId().meta({ privacy: privacy.nonPii }),
    createdAt: z.date().meta({ privacy: privacy.nonPii }),
    updatedAt: z.date().meta({ privacy: privacy.nonPii }),
    team: zExt.objectId().meta({ privacy: privacy.nonPii }),
    name: z.string().meta({ privacy: privacy.nonPii }),
    locationId: locationIdFormat.schema
      .meta({ privacy: privacy.nonPii })
      .nullish(),
  })
  .meta({ privacy: privacy.structured });
export const RedoFulfillmentToteGroupSchema: z.ZodType<RedoFulfillmentToteGroup> =
  RedoFulfillmentToteGroupSchema_;

export interface RedoFulfillmentToteGroup extends z.infer<
  typeof RedoFulfillmentToteGroupSchema_
> {}
